import createMuiTheme, { ThemeOptions } from '@material-ui/core/styles/createMuiTheme'

const createTheme = (options: ThemeOptions) => createMuiTheme({ ...options })

export default createTheme
